import { render } from "./supportInner.vue?vue&type=template&id=a1598ad4&scoped=true"
import script from "./supportInner.vue?vue&type=script&lang=js"
export * from "./supportInner.vue?vue&type=script&lang=js"

import "./supportInner.vue?vue&type=style&index=0&id=a1598ad4&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1598ad4"]])

export default __exports__